<template>
  <res-form
    title="Resolución Exenta"
    type-document="RES"
  />
</template>
<script>
import ResForm from '@/febos/global/customDocuments/vistas/empresas/72235100-2/components/ResForm';

export default {
  name: 'RES',
  components: { ResForm }
};
</script>
